import type {
  Control,
  FieldValues,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form';

export const RESTRICTION_TYPE_KEYS = [
  'frequencyLimits',
  'stepSizeLimits',
  'totalLimits',
  'lifeEventLimits',
  'formulaBasedRestrictions',
  'exclusionPeriods',
  'conditionalContactAgeRestrictions',
] as const;

export type RestrictionType = (typeof RESTRICTION_TYPE_KEYS)[number];

export interface BaseRestrictionFormProps {
  index: number;
  control: Control<FieldValues>;
  restrictionSetPath: string;
  onRemove?: () => void;
}

export interface RestrictionFormPropsWithSetValue extends BaseRestrictionFormProps {
  setValue: UseFormSetValue<FieldValues>;
}

export interface RestrictionFormPropsWithTrigger extends BaseRestrictionFormProps {
  trigger: UseFormTrigger<FieldValues>;
}
